module.exports = __webpack_public_path__ + "sm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/sm.svg
// module id = 809
// module chunks = 0